import { asyncRoute } from '../../router';

export default asyncRoute(() =>
  import(/* webpackChunkName: "PromoBonusContainer" */ './container/PromoBonusContainer')
);
